import React, { Component } from 'react';
import axios from "axios";
import {appConfig} from "./../tools/AppConfig";
import Waiting from './../modules/waiting';
import Form from 'react-validation/build/form';
import Button from 'react-validation/build/button';
import Input from 'react-validation/build/input';
import Message from './errors/messagePrem';
import SimpleHeader from './../modules/simpleHeader_prem';
import Card from './../modules/paymentMethods/card_prem';
import Wallet from './../modules/paymentMethods/wallet_prem';
import Cash from './../modules/paymentMethods/cash_prem';
import Aman from './../modules/paymentMethods/aman_prem';
import Premium from './../modules/paymentMethods/premium_prem';
import Valu from './../modules/paymentMethods/valu_prem';
import Jawwal from './../modules/paymentMethods/Jawwal';
import Delivery from './../modules/paymentMethods/delivery_prem';
import SubData from './../modules/paymentMethods/sub-data_prem';
import amanImg from './../../statics/img/payment_methods_logos/logo_aman.png';
import masaryImg from './../../statics/img/payment_methods_logos/logo_masary.png';
import cashImg from './../../statics/img/payment_methods_logos/logo_cash.png';
import cardImg from './../../statics/img/payment_methods_logos/logo_mc_visa.png';
import walletImg from './../../statics/img/payment_methods_logos/logo_wallet.png';
import premiumImg from './../../statics/img/payment_methods_logos/logo_premium.gif';
import compLogo from './../../statics/premCheck/compLogo.png';
import favicon from './../../statics/img/favicon.svg';
import favicon_jawwal from './../../statics/img/fav_icon.png';

import './../custom.css';
import './invoice.css';
import { Container, Row, Col } from 'reactstrap';

import 'icheck/skins/all.css'; // or single skin css
import {Radio, RadioGroup} from 'react-icheck';
import validator from 'validator';

import creditCard from './../../statics/premCheck/credit-card.png';
import funds from './../../statics/premCheck/funds.png';
import vodafone from './../../statics/premCheck/vodafone.png';
import kiosk from './../../statics/premCheck/kiosk.png';
import valu from './../../statics/premCheck/valu.png';
import wallet from './../../statics/premCheck/wallet.png';
import testImg from './../../statics/premCheck/testImg.png';
import footerLogo from './../../statics/premCheck/Logo.png';
import valuImg from './../../statics/img/payment_methods_logos/ValU.png';
import user from './../../statics/premCheck/user.png';
import product_def from './../../statics/premCheck/product-default.jpg';
import acceptWhiteImg from './../../statics/img/accept_white.png';
import success from './../../statics/premCheck/success.png';
import fail from './../../statics/premCheck/fail.png';


const required = (value) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> This field is require.</div>;
  }
};
const quantityRule = (value) => {
    //isDecimal(str [, options])
    //isInt(str [, options])
    // 
    if (!validator.isInt(value.toString(), {min: 1, max: 100}) ) {
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid integer between 1 and 100</div>;
    }
};

class product extends Component {
    constructor(props){
        super(props);
        this.state = {
            dataLoaded: false,
            userData: null,
            requestComplete: false,
            completeMessage: {'head': "", 'body': ""},
            quantity: 1,
            total: null,
            quantityFormComplete: false,
            currentMethod: '',
            MethodsName: {
                VPC: "Card",
                UIG: "Wallet",
                CASH: "Cash Collection",
                CAGG: "Accept Kiosk",
                PREMIUM: "Premium",
                VALU: "Valu",
                MPAY: "Jawwal Pay"
            },
            paymentMethodsDisable: true,
            deliveryDataCollected: false,
            deliveryData: {

            },
            SubDataComplelte:true,
            editBtn:false,
            //acq_partner
            acq_partner: false,
            styleData: {}
        };
        this.renderError  = this.renderError.bind(this);
        this.renderBody = this.renderBody.bind(this);
        this.paymentsMethods = this.paymentsMethods.bind(this);
        this.renderCurrentImg = this.renderCurrentImg.bind(this);
        this.disableAllPaymentMethods = this.disableAllPaymentMethods.bind(this);
        this.enableAllPaymentMethods = this.enableAllPaymentMethods.bind(this);
        this.handleMethodChange = this.handleMethodChange.bind(this);
        this.renderPaymentMethod = this.renderPaymentMethod.bind(this);
        this.currentPaymentMethodComponent = this.currentPaymentMethodComponent.bind(this);
        this.setDeliveryData = this.setDeliveryData.bind(this);
        this.setSubDeliveryData = this.setSubDeliveryData.bind(this);
        this.setReqComplete = this.setReqComplete.bind(this);
        this.handelQuantityChange = this.handelQuantityChange.bind(this);
        this.handleQuantitySubmit = this.handleQuantitySubmit.bind(this);
        this.setPartnerColors = this.setPartnerColors.bind(this);
        this.loadData = this.loadData.bind(this);
        this.loadStyleData();
        this.setSubDataComplelte = this.setSubDataComplelte.bind(this);
        this.incrementQuantity = this.incrementQuantity.bind(this);
        this.decrementQuantity = this.decrementQuantity.bind(this);

        
        
    }
    setSubDataComplelte(){
        this.setState({SubDataComplelte: false});
    }
    incrementQuantity(e){
        e.preventDefault();
        this.setState({quantity: this.state.quantity+1},()=>{
            this.handelQuantityChangeIncDec()
        });
    }
    decrementQuantity(e){
        e.preventDefault();
        
        this.setState({quantity: this.state.quantity-1},()=>{
            if(this.state.quantity<=0){
                this.setState({quantity: 1},()=>{
                    this.handelQuantityChangeIncDec()
                });
            };
            this.handelQuantityChangeIncDec()
        });

    }
    loadStyleData(){
        let styleUrl = appConfig.getServerUrl() + '/api/auth/acq_partners/style?url=' + window.location.hostname;
        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        axios.get(
            styleUrl,
            config
        )
        .then((respond)=>{
            this.setState({styleData: respond.data, acq_partner: true},()=>{
                this.loadData();
            })
        })
        .catch((err)=>{
            this.loadData();
        });
    }
    loadData(){
        let token = this.props.token;
        let productUrl = appConfig.getServerUrl() + '/product_prem/' + token;
        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        axios.get(
            productUrl,
            config
        )
        .then((respond)=>{
            if(respond.data.error){
                this.setReqComplete({head: '', body: respond.data.error,icon:fail});
            } else {
                this.setState({ userData: respond.data, dataLoaded: true, total: respond.data.amount, quantityFormComplete: !respond.data.product.allow_quantity_edit, paymentMethodsDisable: respond.data.product.allow_quantity_edit }, () => {
                    
                    let current_integrations_keys = [];
                    let all_integ_key_arr = Object.keys(this.state.userData.integrations);
                    for(let i=0; i< all_integ_key_arr.length;i++){
                        if(this.state.MethodsName[all_integ_key_arr[i]]){
                            current_integrations_keys.push(all_integ_key_arr[i]);
                        }
                    }
                    this.setState({currentMethod: current_integrations_keys[0]},()=>{
                        if(this.state.acq_partner){
                            this.setPartnerColors(this.state.styleData)
                        }else{
                            const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                            link.rel="shortcut icon"
                            link.type = 'image/x-icon'
                            link.href= favicon;
                        }
                    })
                });
                localStorage.userData=JSON.stringify(respond.data)

            }
        })
        .catch((err)=>{
            if(this.state.acq_partner){
                this.setPartnerColors(this.state.styleData)
            }else{
                const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link.rel="shortcut icon"
                link.type = 'image/x-icon'
                link.href= favicon;
            }
            this.setReqComplete({head: 'Connection error', body:'Oops! Something went wrong. If this problem persists, please contact your service provider.'});
        });
    }
    setPartnerColors(data){
        setTimeout(()=>{
            document.querySelectorAll(".acq_partner").forEach(el => el.style.background = data.partner_css.header_background);
            const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.rel="shortcut icon"
            link.type = 'image/x-icon'
            link.href= favicon_jawwal;
        },40)
    }
    paymentsMethods(){
        let current_integrations_keys = [];
        let all_integ_key_arr = Object.keys(this.state.userData.integrations);
        for(let i=0; i< all_integ_key_arr.length;i++){
            if(this.state.MethodsName[all_integ_key_arr[i]]){
                current_integrations_keys.push(all_integ_key_arr[i]);
            }
        }
      
        //   "radioClass": "iradio_minimal",
        //    "radioClass": "iradio_flat-red",

        return(
            <RadioGroup className="methodsContent" name="radio" defaultValue={current_integrations_keys[0]} onChange = {this.handleMethodChange}>
                {current_integrations_keys.map((key, index) => {
                    return <Radio 
                        radioClass="iradio_flat-green"
                        increaseArea="20%"
                        key= {key}
                        value={key}
                        label={"<div class='paymentIcon'>"+ this.renderCurrentImg(key)+"</div>" + "<span>" +this.state.MethodsName[key] + "</span>" }
                        // disabled={this.state.paymentMethodsDisable}
                    />
                })} 
            </RadioGroup>
        );
    }

    renderCurrentImg(key){
        let allowedAggre = this.state.userData.allowed_aggregators;
        if(key === 'VPC'){
            return "<img class='' src=" + creditCard + " alt=" + key + " /></div>"
        }else if(key === 'UIG'){
            return "<img class='' src=" + wallet + " alt=" + key + " />"
        }else if(key === 'CASH'){
            return "<img class='' src=" + funds + " alt=" + key + " />"
        }else if(key === 'CAGG'){
            return "<img class='' src=" + kiosk + " alt=" + key + " />"
        }else if(key === 'PREMIUM'){
            return "<img class='' src=" + valu + " alt=" + key + " />"
        }else if(key === 'VALU'){
            return "<img class='paymentMethodImg' src=" + valuImg + " alt=" + key + " />"
        }
        return ''
    }
    disableAllPaymentMethods(){
        this.setState({paymentMethodsDisable: true});
    }
    enableAllPaymentMethods(){
        this.setState({paymentMethodsDisable: false});
    }
    handleMethodChange(e){
        this.setState({currentMethod: e.target.value});
    }
    handelQuantityChange(e){
        //update total
        let newTotal = e.target.value * this.state.userData.amount;
        this.setState({quantity: e.target.value, total: newTotal});
    }
    handelQuantityChangeIncDec(){
        //update total
        let newTotal =(this.state.quantity * this.state.userData.amount).toFixed(1);
        this.setState({ total: newTotal});
    }
    handleQuantitySubmit(event){
        event.preventDefault();
        this.setState({quantityFormComplete: true});
    }
    renderPaymentMethod() {
        let deliveryNeed = this.state.userData.product.delivery_needed;
        if(deliveryNeed === false){
            //here
            if(this.state.deliveryDataCollected){
                return this.currentPaymentMethodComponent();
            }else{
                return <SubData
                        userData={this.state.userData}
                        setSubDeliveryData={this.setSubDeliveryData} 
                        quantity={this.state.quantity}
                        total={this.state.total} handelQuantityChange={this.handelQuantityChange}
                        handleQuantitySubmit={this.handleQuantitySubmit} 
                        quantityFormComplete={this.state.quantityFormComplete} 
                        setSubDataComplelte={this.setSubDataComplelte} 
                        incrementQuantity={this.incrementQuantity} decrementQuantity={this.decrementQuantity}
                        quantityFormComplete = {this.state.quantityFormComplete}
                        />
            }
            //return this.currentPaymentMethodComponent();SubData
        }else if (deliveryNeed === true){
            if(this.state.deliveryDataCollected){
                return this.currentPaymentMethodComponent();
            }else{
                return <Delivery sourcePage='product' userData={this.state.userData} setDeliveryData={this.setDeliveryData} currentDeliveryData={this.state.deliveryData}
                quantity={this.state.quantity}
                total={this.state.total} handelQuantityChange={this.handelQuantityChange}
                handleQuantitySubmit={this.handleQuantitySubmit} 
                quantityFormComplete={this.state.quantityFormComplete} 
                setSubDataComplelte={this.setSubDataComplelte} 
                incrementQuantity={this.incrementQuantity} decrementQuantity={this.decrementQuantity}
                />
                // dlv
            }
        }
        
    }
    setDeliveryData(data) {
        this.setState({deliveryDataCollected: true, deliveryData: {...data}});
    }
    setSubDeliveryData(data) {
        this.setState({deliveryDataCollected: true, deliveryData: {...data}});
    }
    setReqComplete(Message){
        this.setState({requestComplete: true, completeMessage: Message, dataLoaded: true});
    }
 
    currentPaymentMethodComponent() {
        let currentMethod = this.state.currentMethod;
        let deliveryNeed = this.state.userData.product.delivery_needed;
        if( currentMethod === 'VPC'){
            if(deliveryNeed === false){
                return <Card
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={false} deliveryData={this.state.deliveryData} userData={this.state.userData} 
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Card 
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} 
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }else if( currentMethod === 'UIG'){
            if(deliveryNeed === false){
                return <Wallet  
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={false} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete}/>
            }else if (deliveryNeed === true){
                return <Wallet  
                    sourcePage='product' 
                    quantity={this.state.quantity}
                    deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }
        }else if( currentMethod === 'CASH'){
            if(this.state.deliveryDataCollected){
                if(this.state.deliveryData.city){
                    return <Cash 
                        sourcePage='product'
                        quantity={this.state.quantity}
                        deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} 
                        setDeliveryData={this.setDeliveryData}
                        editBtn = { false }
                    />
                }else{
                    // return <Delivery sourcePage='product' userData={this.state.userData} setDeliveryData={this.setDeliveryData} currentDeliveryData={this.state.deliveryData}/>
                    return <Cash 
                        sourcePage='product'
                        quantity={this.state.quantity}
                        deliveryNeed={false} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} 
                        setDeliveryData={this.setDeliveryData}
                        editBtn = { true }
                        />
                }                
            }else{
                return <Delivery sourcePage='product' userData={this.state.userData} setDeliveryData={this.setDeliveryData} currentDeliveryData={this.state.deliveryData}/>
            }
            if(deliveryNeed === false){
                return <Wallet 
                    sourcePage='product' 
                    quantity={this.state.quantity}
                    deliveryNeed={false} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }else if (deliveryNeed === true){
                return <Wallet 
                    sourcePage='product' 
                    quantity={this.state.quantity}
                    deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }
        }else if( currentMethod === 'CAGG'){
            if(deliveryNeed === false){
                return <Aman 
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={false} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }else if (deliveryNeed === true){
                return <Aman 
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }
        }else if( currentMethod === 'PREMIUM'){
            if(deliveryNeed === false){
                return <Premium 
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={false} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Premium 
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }else if( currentMethod === 'VALU'){
            if(deliveryNeed === false){
                return <Valu 
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={false} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Valu 
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }else if( currentMethod === 'MPAY'){
            if(deliveryNeed === false){
                return <Jawwal sourcePage='product' 
                    quantity={this.state.quantity}
                    deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Jawwal sourcePage='product' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }else{
            return <p>{this.state.MethodsName[this.state.currentMethod]}</p>
        }
    }
    renderError(){
        return ( 
            <div className="invoice">
                {/* <SimpleHeader userData={this.state.userData} /> */}
                <Container>
                    <div className="checkHeader">
                        <div className="compLogo">
                            <a href="#">
                                <img src={appConfig.getServerUrl() + this.state.userData.logo_uri}/>
                            </a>
                        </div>
                        <p className="companyName">
                        {this.state.userData.merchant_name}
                        </p>
                    </div>
                </Container>
                <Message body={this.state.userData.errorMessage} />
            </div>
        );
    }
    renderBody(){
        //<h1>invoice {this.props.match.params.id} page</h1>
        if(this.state.requestComplete){
            let userData=this.state.userData;
            return ( 
                <div className="invoice">
                    {/* <SimpleHeader userData={this.state.userData}/> */}
                    <Container>
                        <div className="checkHeader invoiceHeader">
                            <div className="leftInvoice">
                                {userData &&
                                     <div className="compLogo">
                                        <a href="#">
                                            <img src={!userData.logo_uri?user:appConfig.getServerUrl() + userData.logo_uri }/>
                                        </a>
                                    </div>
                                }
                                {userData &&
                                     <p className="companyName">
                                        {userData.merchant_name?userData.merchant_name:"-"}
                                    </p>
                                }
                                </div>
                            </div>
                        </Container>  
                    <div>
                        <Message head={this.state.completeMessage.head} body={this.state.completeMessage.body } icon={this.state.completeMessage.icon}/>
                    </div>
                    <div className="premFooter">
                        <p>Powered by</p>
                        <a href="https://www.weaccept.co/"><img src={footerLogo}></img></a>
                    </div>
                </div>
            );
        }else{
            return (
                <div className="invoice">
                    {/* <SimpleHeader /> */}
                        <Container>
                            <div className="checkHeader">
                                <div className="compLogo">
                                    <a href="#">
                                    <img src={this.state.userData.logo_uri==""?user:appConfig.getServerUrl() + this.state.userData.logo_uri}/>
                                    </a>
                                </div>
                                <p className="companyName">
                                {this.state.userData.merchant_name}
                                </p>
                            </div>
                        </Container>
                    {!this.state.SubDataComplelte?
                        <Container>
                            <div className="productSummery">
                                <div className="leftSummery">
                                    <div className="summeryImg">
                                        <img src={this.state.userData.product_image_uri==""?product_def:appConfig.getServerUrl() + this.state.userData.product_image_uri} />
                                    </div>
                                    <h3>
                                    {this.state.userData.product_name}
                                    </h3>
                                </div>
                                <div className="rightSummery">
                                    <div className="rightDiv">
                                        <h5>Unit Price</h5>
                                        <p>{(this.state.userData.amount) + ' ' + this.state.userData.currency}</p>
                                    </div>
                                    <div className="rightDiv">
                                        <h5>Amount</h5>
                                        <p>{this.state.quantity}</p>
                                    </div>
                                    <div className="rightDiv">
                                        <h5>Total</h5>
                                        <p>{(this.state.total ) + ' ' + this.state.userData.currency}</p>
                                    </div>
                                </div>
                            </div>
                        </Container>
                    :
                    null
                    }
                    <Container>
                        <Row>
                            {/* <Col lg="6" md="12" sm="12"> */}
                            <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 ">

                            {/* here */}
                               {!this.state.SubDataComplelte?
                                    <div>
                                        <div className="premPanel">
                                            <div className="premHeader" >
                                                <h2>Choose Payment Method</h2>
                                            </div>
                                            <div className="paymentMethods">
                                                {this.paymentsMethods()}
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div>
                                        <div className="productImg">
                                        <img src={this.state.userData.product_image_uri==""?product_def:appConfig.getServerUrl() + this.state.userData.product_image_uri} />
                                        </div>
                                        <div className="productDetails">
                                            <div className="namePrice">
                                                <div className="productName">
                                                    <h4>Product Name</h4>
                                                    <b>{this.state.userData.product_name}</b>
                                                </div>
                                                <div className="productPrice">
                                                    <h4>Price</h4>
                                                    <b>
                                                        <label value="">
                                                            {(this.state.userData.amount) + ' ' + this.state.userData.currency}
                                                        </label>
                                                    </b>
                                                </div>
                                            </div>
                                            <div className="productDesc">
                                                <h4>Description</h4>
                                                <p>
                                                {this.state.userData.description}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                }
                                </div>
                            {/* </Col> */}
                            {/* <Col lg="1" sm="0"></Col> */}
                            {/* <Col lg="6" md="12" sm="12"> */}
                            <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 ">
                                {this.renderPaymentMethod()}     
                            </div>  
                            <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 ">
                              <h1>nessma</h1> 
                            </div>
                            {/* </Col> */}
                        </Row>
                    </Container>
                    {this.state.acq_partner ? 
                        <div className="premFooter" style={{background: this.state.styleData.partner_css.header_background}}>
                            <p>Powerd by</p>
                            <a href={this.state.styleData.partner_redirect_url}><img src={this.state.styleData.partner_logo}></img></a>
                        </div>
                    :
                        <div className="premFooter">
                            <p>Powerd by</p>
                            <a href="https://www.weaccept.co/"><img src={footerLogo}></img></a>
                        </div>
                    }
                </div>   
            );
        }
    }
    render(){
        return (
            <div>
                {this.state.dataLoaded?this.renderBody():<Waiting height='100vh' />}
            </div>
        );
    }
    
}

export default product;
